import { styled, useTheme } from "@mui/material";

const DotComponent = styled("span")(() => ({
  display: "inline-block",
  borderRadius: "50%",
  marginRight: 6,
  flexShrink: 0,
}));

interface DotProps extends React.HTMLAttributes<HTMLSpanElement> {
  bgcolor?: string;
  colorType?: string;
  size?: number;
}

function Dot(props: DotProps) {
  const { bgcolor, size = 10, colorType, style, ...rest } = props;

  const theme = useTheme();

  return (
    <DotComponent
      aria-hidden="true"
      data-color-type={colorType}
      sx={{
        width: size,
        height: size,
        background: bgcolor || theme.palette.grey[40],

        "&[data-color-type='gradient']": {
          background: `linear-gradient(90deg, ${theme.palette.grey[60]} 36.96%, ${theme.palette.secondary1[60]} 106.09%)`,
        },
        "&[data-color-type='negative']": {
          background: theme.palette.secondary2[60],
        },
        "&[data-color-type='neutral']": {
          background: theme.palette.grey[60],
        },
        "&[data-color-type='positive']": {
          background: theme.palette.secondary1[60],
        },
      }}
      {...rest}
    />
  );
}

export default Dot;
